import React from 'react';
const bonuses = [{
  badge: 'BONUS #1 — VALORADO EN $9.95',
  title: 'Decodificador de Etiquetas: 56 Nombres del Azúcar',
  subtitle: 'La guía de bolsillo que tu supermercado no quiere que uses',
  img: 'https://cdn.magicpatterns.com/uploads/2g8fWemRTNhKHrzpLvZY2y/Portada_Bono_1.png',
  bullets: ['14 páginas con los 56 nombres bajo los que se esconde el azúcar', 'Color coded: rojo, amarillo, verde', 'Para identificar cada ingrediente de un vistazo', 'Para leer cualquier etiqueta en 60 segundos']
}, {
  badge: 'BONUS #2 — VALORADO EN $9.95',
  title: 'Mecanismo de Rescate — 6 Tarjetas de Emergencia',
  subtitle: 'Qué hacer en los próximos 15 minutos si la comida fue alta en carbohidratos',
  img: 'https://cdn.magicpatterns.com/uploads/fGywZHm5sAFxTJ8HRHrKV3/Portada_Bono_2.png',
  bullets: ['13 páginas con 3 estrategias de rescate respaldadas por estudios', 'Sin culpa, sin perfeccionismo', 'Incluye: El Orden del Plato, La Caminata de Digestión Muscular, El Vinagre como Modulador', '6 tarjetas recortables para llevar siempre contigo']
}, {
  badge: 'BONUS #3 — VALORADO EN $14.95',
  title: 'Menú Semanal Anti-Glicación: 7 Días con Lista de Compras',
  subtitle: 'Lo que la ciencia dice que funciona, traducido en platos reales',
  img: 'https://cdn.magicpatterns.com/uploads/mFQ4EuLTn6r2WXq5jT4qZ1/Portada_Bono_3.png',
  bullets: ['18 páginas con un plan de 7 días', '90 min que te ahorran toda la semana', 'Lista organizada por secciones del supermercado', '3 bases de sustitución hacia alimentación anti-glicatoria']
}];
export function Bonuses() {
  return <section className="py-20 md:py-28 px-4 bg-dark-secondary" data-id="element-88">
      <div className="max-w-content mx-auto" data-id="element-89">
        <div className="text-center mb-16" data-id="element-90">
          <span className="inline-block font-mono text-[11px] text-gold uppercase tracking-[0.2em] mb-4" data-id="element-91">
            LOS 3 BONUS EXCLUSIVOS
          </span>
          <h2 className="font-serif text-3xl md:text-4xl text-cream leading-tight max-w-2xl mx-auto" data-id="element-92">
            Tres herramientas que convierten el conocimiento de la guía en
            acción inmediata
          </h2>
        </div>

        <div className="space-y-8" data-id="element-93">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-dark-card border-l-[4px] border-gold rounded-r-lg p-6 md:p-8 flex flex-col md:flex-row gap-8" data-id="element-94">
              {/* Left: Image */}
              <div className="w-full md:w-1/4 flex justify-center md:justify-start shrink-0" data-id="element-95">
                <img src={bonus.img} alt={bonus.title} className="w-[140px] md:w-full h-auto rounded-sm shadow-xl border border-border-subtle" data-id="element-96" />
              </div>

              {/* Right: Content */}
              <div className="w-full md:w-3/4" data-id="element-97">
                <span className="inline-block bg-gold/10 text-gold font-mono text-[10px] uppercase tracking-widest px-3 py-1 rounded mb-4" data-id="element-98">
                  {bonus.badge}
                </span>
                <h3 className="font-serif text-2xl text-cream mb-2" data-id="element-99">
                  {bonus.title}
                </h3>
                <p className="font-serif italic text-gray-warm text-[16px] mb-6" data-id="element-100">
                  {bonus.subtitle}
                </p>

                <ul className="space-y-3 mb-6" data-id="element-101">
                  {bonus.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start gap-3" data-id="element-102">
                      <span className="text-gold shrink-0 mt-1.5 text-[10px]" data-id="element-103">
                        ●
                      </span>
                      <span className="font-sans text-cream/90 text-[15px] leading-relaxed" data-id="element-104">
                        {bullet}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}